import { defineStore } from "pinia";

import modelClass from "@models/inmail";
import * as getters from "@modelStores/helpers/getters-helper";

export const useInmailStore = defineStore("inmail-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
